import { enqueue, dequeue } from './eventStack';

const initStars = {};
const bubbleStars = {};

// cartesian product of name parts and stars
// adjusted appropriately for special cases
function variants(name, initial) {
  const map = initial ? initStars : bubbleStars;
  if (map[name]) return map[name];

  const parts = name.split('.');
  const result = [];
  let base = false;

  // initial events the implicit namespace of 'this'
  if (initial) {
    parts.unshift('this');
    base = true;
  }

  // use max - 1 bits as a bitmap to pick a part or a *
  // need to skip the full star case if the namespace is synthetic
  const max = Math.pow(2, parts.length) - (initial ? 1 : 0);
  for (let i = 0; i < max; i++) {
    const join = [];
    for (let j = 0; j < parts.length; j++) {
      join.push(1 & (i >> j) ? '*' : parts[j]);
    }
    result.unshift(join.join('.'));
  }

  if (base) {
    // include non-this-namespaced versions
    if (parts.length > 2) {
      result.push.apply(result, variants(name, false));
    } else {
      result.push('*');
      result.push(name);
    }
  }

  map[name] = result;
  return result;
}

export default function fireEvent(blcktive, eventName, context, args = []) {
  if (!eventName) {
    return;
  }

  context.name = eventName;
  args.unshift(context);

  const eventNames = blcktive._nsSubs ? variants(eventName, true) : ['*', eventName];

  return fireEventAs(blcktive, eventNames, context, args, true);
}

function fireEventAs(blcktive, eventNames, context, args, initialFire = false) {
  let bubble = true;

  if (initialFire || blcktive._nsSubs) {
    enqueue(blcktive, context);

    let i = eventNames.length;
    while (i--) {
      if (eventNames[i] in blcktive._subs) {
        bubble = notifySubscribers(blcktive, blcktive._subs[eventNames[i]], context, args) && bubble;
      }
    }

    dequeue(blcktive);
  }

  if (blcktive.parent && bubble) {
    if (initialFire && blcktive.component) {
      const fullName = blcktive.component.name + '.' + eventNames[eventNames.length - 1];
      eventNames = variants(fullName, false);

      if (context && !context.component) {
        context.component = blcktive;
      }
    }

    bubble = fireEventAs(blcktive.parent, eventNames, context, args);
  }

  return bubble;
}

function notifySubscribers(blcktive, subscribers, context, args) {
  let originalEvent = null;
  let stopEvent = false;

  // subscribers can be modified inflight, e.g. "once" functionality
  // so we need to copy to make sure everyone gets called
  subscribers = subscribers.slice();

  for (let i = 0, len = subscribers.length; i < len; i += 1) {
    if (!subscribers[i].off && subscribers[i].handler.apply(blcktive, args) === false) {
      stopEvent = true;
    }
  }

  if (context && stopEvent && (originalEvent = context.event)) {
    originalEvent.preventDefault && originalEvent.preventDefault();
    originalEvent.stopPropagation && originalEvent.stopPropagation();
  }

  return !stopEvent;
}
